var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { MarketTab } from '../../app/router/config';
import { SettingsContext } from '../../context/settings';
import { UserContext } from '../../context/user';
import ariseCoinsData from '../../data/products/arise-coins.json';
import cardsData from '../../data/products/cards.json';
import chestsData from '../../data/products/chests.json';
import mintPassesData from '../../data/products/mint-passes.json';
import presalePacksData from '../../data/products/presale-packs.json';
import presaleTicketsData from '../../data/products/presale-tickets.json';
import shardsData from '../../data/products/shards.json';
import souvenirCardsData from '../../data/products/souvenir-cards.json';
import { appEnv } from '../../env';
import { SortDirection, TokenType } from '../../types/common';
export var ProductsOrderBy;
(function (ProductsOrderBy) {
    ProductsOrderBy["NAME"] = "name";
    ProductsOrderBy["POWER"] = "power";
})(ProductsOrderBy || (ProductsOrderBy = {}));
export function useProducts(filters) {
    var systemInfo = useContext(UserContext).systemInfo;
    var setShowFilters = useContext(SettingsContext).setShowFilters;
    var cardsTake = useState(40)[0];
    var _a = useState(0), cardTakeStartIndex = _a[0], setCardTakeStartIndex = _a[1];
    var _b = useState(undefined), allDisplayedCards = _b[0], setAllDisplayedCards = _b[1];
    var _c = useState(undefined), displayedCards = _c[0], setDisplayedCards = _c[1];
    var _d = useState(undefined), displayedMintPasses = _d[0], setDisplayedMintPasses = _d[1];
    var _e = useState(undefined), displayedPresalePacks = _e[0], setDisplayedPresaleCards = _e[1];
    var _f = useState(undefined), displayedPresaleTickets = _f[0], setDisplayedPresaleTickets = _f[1];
    var _g = useState(undefined), displayedChests = _g[0], setDisplayedChests = _g[1];
    var _h = useState(undefined), displayedShards = _h[0], setDisplayedShards = _h[1];
    var _j = useState(undefined), displayedSouvenirCards = _j[0], setDisplayedSouvenirCards = _j[1];
    var _k = useState(undefined), displayedAriseCoins = _k[0], setDisplayedAriseCoins = _k[1];
    useEffect(function () {
        if (filters.state.tokenTypes[0] !== TokenType.CARD && filters.state.orderBy === ProductsOrderBy.POWER) {
            filters.actions.setOrderBy(ProductsOrderBy.NAME);
            filters.actions.setDirection(SortDirection.ASC);
        }
        else if (filters.state.orderBy === ProductsOrderBy.POWER) {
            filters.actions.setDirection(SortDirection.DESC);
        }
        else {
            filters.actions.setDirection(SortDirection.ASC);
        }
    }, [filters.state.orderBy, filters.state.tokenTypes]);
    useEffect(function () {
        function onFiltersChange() {
            function filterCards(card) {
                if (filters.state.tab !== MarketTab.PRODUCTS) {
                    setDisplayedCards(undefined);
                    setDisplayedMintPasses(undefined);
                    setDisplayedShards(undefined);
                    setDisplayedSouvenirCards(undefined);
                    return;
                }
                var elements = card.elements;
                var searchQuery = filters.state.searchQuery.value;
                var elementsIncluded = false;
                for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
                    var element = elements_1[_i];
                    if (filters.state.elements.includes(element)) {
                        elementsIncluded = true;
                        break;
                    }
                }
                return ((filters.state.collections.length === 0 || filters.state.collections.includes(card.season)) &&
                    (filters.state.sets.length === 0 || filters.state.sets.includes(card.set)) &&
                    (filters.state.elements.length === 0 || elementsIncluded) &&
                    (filters.state.advancements.length === 0 ||
                        filters.state.advancements.includes(card.advancement)) &&
                    (filters.state.rarities.length === 0 || filters.state.rarities.includes(card.rarity)) &&
                    (filters.state.factions.length === 0 || filters.state.factions.includes(card.faction)) &&
                    (filters.state.cardTypes.length === 0 || filters.state.cardTypes.includes(card.type)) &&
                    (searchQuery.length === 0 ||
                        card.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        card.description.toLowerCase().includes(searchQuery.toLowerCase())));
            }
            var searchQuery = filters.state.searchQuery.value;
            var cardsWithoutDuplicatedCombo = [];
            var _loop_1 = function (card) {
                var index = cardsWithoutDuplicatedCombo.findIndex(function (item) { return item.ian === card.ian; });
                if (index === -1) {
                    cardsWithoutDuplicatedCombo.push(card);
                }
            };
            for (var _i = 0, cardsData_1 = cardsData; _i < cardsData_1.length; _i++) {
                var card = cardsData_1[_i];
                _loop_1(card);
            }
            var cards = cardsWithoutDuplicatedCombo
                .filter(filterCards)
                .filter(function (card) { return !appEnv.isLive || !card.releaseDate || moment(card.releaseDate).isBefore(systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.serverTime); })
                .sort(function (a, b) {
                var powerResult = filters.state.direction === SortDirection.ASC
                    ? a.nominalPower - b.nominalPower
                    : b.nominalPower - a.nominalPower;
                var nameDiff = b.name.toLowerCase() < a.name.toLowerCase() ? 1 : -1;
                var nameResult = filters.state.direction === SortDirection.ASC ? nameDiff : -nameDiff;
                if (filters.state.orderBy === ProductsOrderBy.POWER && a && b) {
                    return powerResult === 0 ? nameResult : powerResult;
                }
                if (filters.state.orderBy === ProductsOrderBy.NAME && a && b) {
                    return nameResult === 0 ? nameDiff : nameResult;
                }
                return 0;
            });
            var mintPasses = mintPassesData.filter(function (mintPass) { return searchQuery.length === 0 || mintPass.name.toLowerCase().includes(searchQuery.toLowerCase()); });
            var presalePacks = presalePacksData.filter(function (presalePack) { return searchQuery.length === 0 || presalePack.name.toLowerCase().includes(searchQuery.toLowerCase()); });
            var presaleTickets = presaleTicketsData.filter(function (presaleTicket) {
                return searchQuery.length === 0 || presaleTicket.name.toLowerCase().includes(searchQuery.toLowerCase());
            });
            var chests = chestsData.filter(function (chest) { return searchQuery.length === 0 || chest.name.toLowerCase().includes(searchQuery.toLowerCase()); });
            var shards = shardsData.filter(function (shard) { return searchQuery.length === 0 || shard.name.toLowerCase().includes(searchQuery.toLowerCase()); });
            var souvenirCards = souvenirCardsData.filter(function (souvenirCard) {
                return (filters.state.grades.length === 0 || filters.state.grades.includes(souvenirCard.grade)) &&
                    (searchQuery.length === 0 || souvenirCard.name.toLowerCase().includes(searchQuery.toLowerCase()));
            });
            var ariseCoins = ariseCoinsData.filter(function (ariseCoin) { return searchQuery.length === 0 || ariseCoin.name.toLowerCase().includes(searchQuery.toLowerCase()); });
            var shortenCards = __spreadArray([], cards, true).slice(0, cardsTake);
            setAllDisplayedCards(cards);
            setDisplayedCards(shortenCards);
            setCardTakeStartIndex(shortenCards.length);
            setDisplayedMintPasses(mintPasses);
            setDisplayedPresaleCards(presalePacks);
            setDisplayedPresaleTickets(presaleTickets);
            setDisplayedChests(chests);
            setDisplayedShards(shards);
            setDisplayedSouvenirCards(souvenirCards);
            setShowFilters(function (value) { return (window.innerWidth > 620 ? value : false); });
            setDisplayedAriseCoins(ariseCoins);
            var container = window.document.getElementById('market-products-grid');
            container === null || container === void 0 ? void 0 : container.scrollTo({ top: 0 });
        }
        onFiltersChange();
    }, [
        filters.state.tokenTypes,
        filters.state.collections,
        filters.state.sets,
        filters.state.advancements,
        filters.state.elements,
        filters.state.rarities,
        filters.state.factions,
        filters.state.grades,
        filters.state.foils,
        filters.state.animationLevels,
        filters.state.cardTypes,
        filters.state.searchQuery.value,
        filters.state.orderBy,
        filters.state.direction,
        filters.state.tab,
        systemInfo,
        cardsTake,
        setShowFilters,
    ]);
    function loadMoreCards() {
        var previousCards = allDisplayedCards || [];
        var shortenCards = __spreadArray([], previousCards, true).slice(0, cardTakeStartIndex + cardsTake);
        setDisplayedCards(shortenCards);
        setCardTakeStartIndex(shortenCards.length);
    }
    function getAssetUrl() {
        switch (filters.state.tokenTypes[0]) {
            case TokenType.CARD: {
                return appEnv.marketplaceImagesUrl.card;
            }
            case TokenType.MINT_PASS: {
                return appEnv.marketplaceImagesUrl.mintPassBackground;
            }
            case TokenType.SOUVENIR_CARD: {
                return appEnv.marketplaceImagesUrl.souvenirCard;
            }
            default: {
                return '';
            }
        }
    }
    return {
        displayedCards: displayedCards,
        displayedMintPasses: displayedMintPasses,
        displayedPresalePacks: displayedPresalePacks,
        displayedPresaleTickets: displayedPresaleTickets,
        displayedChests: displayedChests,
        displayedShards: displayedShards,
        displayedSouvenirCards: displayedSouvenirCards,
        displayedAriseCoins: displayedAriseCoins,
        getAssetUrl: getAssetUrl,
        loadMoreCards: loadMoreCards,
    };
}
